module.exports = __webpack_public_path__ + "static/media/more-header-particles.e971591d.svg";